export default __webpack_public_path__ + "static/media/casa-frente-mobile.8d50d794.jpg";